module.exports = "/_next/static/images/f20804c97466866a663f7e4903e290f2-rewards-app-xs@1x.png";